import React from 'react';
import {Link} from 'react-router-dom';
import AurAnimatedCard from '../../../common/aur-animated-card/AurAnimatedCard';

const AnimatedCard: React.FC = () => {
  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Animated Card</h1>
        Cards contain content and actions about a single subject.
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <AurAnimatedCard>
            <div>hello</div>
          </AurAnimatedCard>
        </div>
      </div>
    </>
  );
};

export default AnimatedCard;
